export const performanceQueryKeys = {
  templates: {
    all: ["performance", "templates"],
    list: (params = {}) => ["performance", "templates", "list", params],
    detail: (id) => ["performance", "templates", "detail", id],
    sectionSourcePreview: (id, sectionId) => [
      "performance",
      "templates",
      id,
      "sections",
      sectionId,
      "source-preview",
    ],
    versions: (id) => ["performance", "templates", id, "versions"],
    version: (id, version) => ["performance", "templates", id, "versions", version],
  },
  ratingScales: {
    all: ["performance", "rating-scales"],
    list: (params = {}) => ["performance", "rating-scales", "list", params],
    detail: (id) => ["performance", "rating-scales", "detail", id],
  },
  imports: {
    all: ["performance", "template-imports"],
    list: (params = {}) => ["performance", "template-imports", "list", params],
    detail: (id) => ["performance", "template-imports", id],
  },
  reviews: {
    all: ["performance", "reviews"],
    list: (params = {}) => ["performance", "reviews", "list", params],
    detail: (id) => ["performance", "reviews", "detail", id],
    my: (params = {}) => ["performance", "reviews", "my", params],
    team: (params = {}) => ["performance", "reviews", "team", params],
  },
};

export default performanceQueryKeys;
